/**
 * Gallery Banner: Video Autoplay + Lightbox Integration
 */
(function() {
  'use strict';

  const VISIBILITY_THRESHOLD = 0.5;

  // ===== VIDEO AUTOPLAY =====
  function initVideoAutoplay() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const videos = document.querySelectorAll('.gallery-banner__video');
    if (videos.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: VISIBILITY_THRESHOLD });

    videos.forEach((video) => {
      video.muted = true;
      video.playsInline = true;
      video.removeAttribute('autoplay');
      observer.observe(video);
    });
  }

  // ===== LIGHTBOX INTEGRATION =====
  function collectGalleryImages() {
    const images = [];

    // Determine which gallery to use based on viewport (matches CSS breakpoint)
    const isMobile = window.innerWidth < 750;
    const visibleGallerySelector = isMobile
      ? '.gallery-banner--mobile .gallery-banner__image'
      : '.gallery-banner--desktop .gallery-banner__image';

    // Fallback if only one gallery exists
    let galleryImages = document.querySelectorAll(visibleGallerySelector);
    if (galleryImages.length === 0) {
      galleryImages = document.querySelectorAll('.gallery-banner__image');
    }

    galleryImages.forEach((img) => {
      let highResSrc = img.currentSrc || img.src;

      // Get largest from srcset if available
      if (img.srcset) {
        const entries = img.srcset.split(',').map(e => {
          const parts = e.trim().split(' ');
          return { url: parts[0], width: parseInt(parts[1]) || 0 };
        });
        entries.sort((a, b) => b.width - a.width);
        if (entries[0]) highResSrc = entries[0].url;
      }

      images.push({
        src: highResSrc,
        alt: img.alt || '',
        width: img.naturalWidth,
        height: img.naturalHeight,
        element: img
      });
    });

    return images;
  }

  function initLightbox() {
    // Wait for zoom viewer to be available
    if (!window.productZoomViewer) {
      if (typeof window.createProductZoomViewer === 'function') {
        window.createProductZoomViewer();
      }
      if (!window.productZoomViewer) {
        setTimeout(initLightbox, 100);
        return;
      }
    }

    const galleryItems = document.querySelectorAll('.gallery-banner__item');

    galleryItems.forEach((item) => {
      if (item.hasAttribute('data-lightbox-initialized')) return;

      const img = item.querySelector('.gallery-banner__image');
      if (!img) return; // Skip video items

      item.addEventListener('click', (e) => {
        e.preventDefault();
        const allImages = collectGalleryImages();
        const currentIndex = allImages.findIndex(i => i.element === img);

        window.productZoomViewer.open(
          allImages,
          Math.max(0, currentIndex),
          item
        );
      });

      item.setAttribute('data-lightbox-initialized', 'true');
    });
  }

  // ===== INIT =====
  function init() {
    initVideoAutoplay();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
